import { render, staticRenderFns } from "./EditMonthlyWorkingHours.vue?vue&type=template&id=1285af47&"
import script from "./EditMonthlyWorkingHours.vue?vue&type=script&lang=js&"
export * from "./EditMonthlyWorkingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports